import styled from 'styled-components'

const H4 = styled.h4`
  font-family: ${p => p.theme.font.heading};
  font-size: 1.375rem;
  color: ${p => p.theme.color.burgundy};
`
export default H4